import React from "react";
import "./NFLToolLayout.css";
import ToolSwitcher from "./ToolSwitcher";

export { default as ToolSwitcher, NFL_TOOLS } from "./ToolSwitcher";
export { default as SeasonSelect } from "./SeasonSelect";

export default function NFLToolLayout({
  tool,
  title,
  subtitle,
  updatedAt,
  actions,
  accentColor,
  filters,
  children,
}) {
  return (
    <div
      className="nfl-tool"
      style={accentColor ? { "--nfl-accent": accentColor } : undefined}
    >
      <ToolSwitcher active={tool} />
      <div className="nfl-title-block">
        <div className="nfl-inner nfl-title-row">
          <div className="nfl-title-text">
            <h1 className="nfl-title nfl-display">{title}</h1>
            {subtitle || updatedAt ? (
              <p className="nfl-subtitle">
                {subtitle}
                {subtitle && updatedAt ? (
                  <span className="nfl-subtitle-dot" aria-hidden="true">
                    ·
                  </span>
                ) : null}
                {updatedAt ? <span>Updated {updatedAt}</span> : null}
              </p>
            ) : null}
          </div>
          {actions ? <div className="nfl-title-actions">{actions}</div> : null}
        </div>
      </div>
      <div className="nfl-rule" />
      {filters}
      <div className="nfl-content">
        <div className="nfl-inner">{children}</div>
      </div>
    </div>
  );
}
